<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.audience.title' | translate"
  [description]="'organizer.edit.audience.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="targetForm.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateAudience()"
>
  <div [formGroup]="targetForm" class="form-group">
    <app-form-input-group
      class="block mb-4"
      [label]="'a11y.organizer.edit.audience.label' | translate"
      [isHiddenLabel]="true"
    >
      <app-form-dropdown
        #content
        formControlName="audience"
        [options]="audienceOptions"
      ></app-form-dropdown>
    </app-form-input-group>

    <app-form-input-group
      *ngIf="isMinAgeVisible"
      class="block mb-2"
      [label]="'organizer.edit.audience.form.age.min.label' | translate"
      [errors]="minAge.errors"
      errorKey="minAge"
    >
      <app-form-input
        #content
        formControlName="minAge"
        [max]="minAgeInputMax"
        [min]="minAgeInputMin"
        [readonly]="minAgeInputReadonly"
        type="number"
      ></app-form-input>
    </app-form-input-group>

    <app-form-input-group
      *ngIf="isMaxAgeVisible"
      [label]="'organizer.edit.audience.form.age.max.label' | translate"
      [errors]="maxAge.errors"
      errorKey="maxAge"
    >
      <app-form-input
        #content
        [formControl]="maxAge"
        [max]="maxAgeInputMax"
        [min]="maxAgeInputMin"
        type="number"
      ></app-form-input>
    </app-form-input-group>

    <ul class="mt-6">
      <li>
        <app-form-checkbox
          formControlName="proficiencyLevelAll"
          [label]="'organizer.edit.audience.form.level.all.label' | translate"
          (change)="updateProficiencyLevels()"
        ></app-form-checkbox>
      </li>
      <li>
        <app-form-checkbox-group
          class="block mt-1"
          [checkboxes]="proficiencyLevelCheckboxes"
          formControlName="proficiencyLevels"
          (change)="updateProficiencyLevelAll()"
        ></app-form-checkbox-group>
      </li>
    </ul>
    <div class="mt-4">
      <app-form-control
        [description]="
          'activity_creation.audience.private.description' | translate
        "
        [title]="'activity_creation.audience.private.title' | translate"
      >
        <app-form-checkbox
          formControlName="visibility"
          [label]="'activity_creation.audience.private.label' | translate"
          (change)="changeVisibility()"
        ></app-form-checkbox>
      </app-form-control>
    </div>
  </div>
</app-organizer-shared-layout-edit-field>
